import { useState, useEffect, useCallback, useRef } from 'react';
import { queryPostHog } from '../utils/posthogApi';

export function usePostHogQuery(queryFn, options = {}) {
  const { deps = [], queryOptions = {} } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  const execute = useCallback(async () => {
    const payload = queryFn();
    if (!payload) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await queryPostHog(payload, queryOptions);
      if (isMounted.current) {
        setData(result);
      }
    } catch (err) {
      if (isMounted.current) {
        setError(err.message);
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    isMounted.current = true;
    execute();
    return () => {
      isMounted.current = false;
    };
  }, [execute]);

  const refresh = useCallback(() => {
    execute();
  }, [execute]);

  return { data, loading, error, refresh };
}
